import script from "./AboutDIGU.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutDIGU.vue?vue&type=script&setup=true&lang=js"

import "./AboutDIGU.vue?vue&type=style&index=0&id=1447b4f7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1447b4f7"]])

export default __exports__